<section>
	<icon type="building" />
	@if (loading) {
		<h3><skeleton width="80%" /></h3>
		<skeletons [customSkeletons]="[['1em', '60%'],['1em', '50%']]" />
		<text-group>
			<skeleton width="50%" />
			<skeleton width="70%" />

			<skeleton width="50%" />
			<skeleton width="70%" />

			<skeleton width="70%" />
			<skeleton width="30%" />
		</text-group>
	}
	@if (!loading) {
		@if (!billingInfoOverride && company) {
			<div span-columns>
				<h3><a (click)="navigateToCompany()">{{ company.name }}</a></h3>
				{{ company.address }}<br />
				{{ company.zipcode }} {{ company.city }}
			</div>
		}
		@if (billingInfoOverride) {
			<div span-columns>
				<h3><a (click)="navigateToCompany()">{{ billingInfoOverride.companyName }}</a></h3>
				{{ billingInfoOverride.streetAddress }}<br />
				{{ billingInfoOverride.zipcode }} {{ billingInfoOverride.city }}
			</div>
		}
		@if (!billingInfoOverride && company) {
			<text-group>
				<span>{{ 'company.vat-number' | translate }}</span>
				<span>{{ company.vatNumber }}</span>

				<span>{{ 'company.establishment-date' | translate }}</span>
				<span>{{ company.establishmentDate | customDate: 'shortDate'}}</span>

				<span>{{ 'company.business-type' | translate }}</span>
				<span>{{ company.businessType }}</span>

				<span>{{ 'company.business-status' | translate }}</span>
				<span>{{ company.businessStatus }}</span>

				<span>{{ 'company.business-code' | translate }}</span>
				<span>{{ company.businessCode }} {{ company.businessName }}</span>

				<span>{{ 'company.advertisement-protection' | translate }}</span>
				<span>{{ (company.advertisingProtection ?  'company.advertisement-protection-true' : 'company.advertisement-protection-false') | translate }}</span>
			</text-group>
		}
		@if (billingInfoOverride) {
			<text-group>
				<span>{{ 'company.vat-number' | translate }}</span>
				<span>{{ billingInfoOverride.vatNumber }}</span>

				<span>{{ 'company.customer-no' | translate }}</span>
				<div>
					@for (setting of customerNumbers; track setting.brandId) {
						<div>{{ setting.customerNo }} <icon small [attr.brand]="setting.brandId | brand:'shortName'" type="logo" /></div>
					}
				</div>

				<span>{{ 'company.billing.has-farpay-direct-debit' | translate }}</span>
				@if (!farPayInfo) { <skeleton width="30%" /> }
				@else {
					@if (farPayError()) { <span>{{ 'company.billing.farpay-error' | translate }}</span> }
					@else if (farPayInfo.customers.length == 0) { <span>{{ 'general.false' | translate }}</span> }
					@else {
						<div>
						@for (farPayCustomer of farPayInfo.customers; track farPayCustomer) {
							<div>
								{{ (farPayPending(farPayCustomer) ? 'company.billing.farpay-pending' : farPayCustomer.agreement?.type == 'LS' ? 'general.true' : 'general.false') | translate }}
								<icon small [attr.brand]="farPayCustomer.brandId | brand:'shortName'" type="logo" />
							</div>
						}
						</div>
					}
				}

				@if (billingInfoOverride.glnNumber) {
					<span>{{ 'company.gln-number' | translate }}</span>
					<span>{{ billingInfoOverride.glnNumber }}</span>
				}
			</text-group>
		}
	}
</section>
@if (farPayInfo && farPayInfo.error) {
	<list-view [selectable]="false">
		<list-item warning statusIcon="exclamation-triangle">
			{{ 'company.billing.farpay-error' | translate }}: {{ farPayInfo.error }}
		</list-item>
	</list-view>
}
